import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../features/auth/useAuth';

export function ProtectedRoute() {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) {
    return <div className="vs-center-page">Laden…</div>;
  }
  // Waar je vandaan kwam meegeven, zodat een sessie die tijdens het werk
  // verloopt je na het opnieuw inloggen terugzet op dezelfde pagina.
  if (!user) return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  return <Outlet />;
}
